module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("html5player_mc_banners", [["div",{"class":"ac-p-toggle-box &&0&& animated fadeIn user-state","data-component":""},[["a",{"href":"","class":"ac-p-banner-link"},[["img",{"class":"ac-p-banner-img large","src":"","alt":""},[],[["largeImg","src",true]]],["textNode",{"text":" "}],["img",{"class":"ac-p-banner-img small","src":"","alt":""},[],[["smallImg","src",true]]]],[["url","href",true]]]],[["cName","class"],["component","data-component",true]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/player/banners.tpl
// module id = 767
// module chunks = 4